import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import { Group as Group$1, CustomPropTypes } from '@zillow/zrs-cms';
import { generateBlockList } from '../../components/BlockList/BlockList.js';

var _excluded = ["alignItems", "backgroundImage", "backgroundImageVisible", "backgroundPosition", "backgroundSize", "borderRadius", "justifyContent", "loading", "margin", "maxWidth", "padding"];
var BlockGroup = function BlockGroup(_ref) {
  var attrs = _ref.attrs,
    innerBlocks = _ref.innerBlocks;
  var _attrs$alignItems = attrs.alignItems,
    alignItems = _attrs$alignItems === void 0 ? {
      default: 'stretch'
    } : _attrs$alignItems,
    backgroundImage = attrs.backgroundImage,
    _attrs$backgroundImag = attrs.backgroundImageVisible,
    backgroundImageVisible = _attrs$backgroundImag === void 0 ? {
      default: true,
      lg_lte: true,
      sm_lte: true
    } : _attrs$backgroundImag,
    backgroundPosition = attrs.backgroundPosition,
    backgroundSize = attrs.backgroundSize,
    borderRadius = attrs.borderRadius,
    _attrs$justifyContent = attrs.justifyContent,
    justifyContent = _attrs$justifyContent === void 0 ? {
      default: 'center'
    } : _attrs$justifyContent,
    _attrs$loading = attrs.loading,
    loading = _attrs$loading === void 0 ? 'lazy' : _attrs$loading,
    _attrs$margin = attrs.margin,
    margin = _attrs$margin === void 0 ? {
      marginBottom: {
        default: 'lg',
        lg_lte: 'md',
        sm_lte: 'sm'
      }
    } : _attrs$margin,
    _attrs$maxWidth = attrs.maxWidth,
    maxWidth = _attrs$maxWidth === void 0 ? {
      default: 'xl'
    } : _attrs$maxWidth,
    _attrs$padding = attrs.padding,
    padding = _attrs$padding === void 0 ? {
      paddingTop: {
        default: 'lg',
        lg_lte: 'md',
        sm_lte: 'sm'
      },
      paddingBottom: {
        default: 'lg',
        lg_lte: 'md',
        sm_lte: 'sm'
      },
      paddingRight: {
        default: 'lg',
        lg_lte: 'md',
        sm_lte: 'sm'
      },
      paddingLeft: {
        default: 'lg',
        lg_lte: 'md',
        sm_lte: 'sm'
      }
    } : _attrs$padding,
    groupProps = _objectWithoutProperties(attrs, _excluded);
  return /*#__PURE__*/React.createElement(Group$1, _extends({
    alignItems: alignItems,
    backgroundImage: backgroundImage,
    backgroundImageVisible: backgroundImageVisible,
    backgroundPosition: backgroundPosition,
    backgroundSize: backgroundSize,
    justifyContent: justifyContent,
    loading: loading,
    maxWidth: maxWidth
  }, borderRadius, groupProps, margin, padding), generateBlockList({
    blocks: innerBlocks
  }));
};
BlockGroup.propTypes = process.env.NODE_ENV !== "production" ? {
  attrs: PropTypes.shape({
    alignItems: CustomPropTypes.inlineMediaQuery(PropTypes.string),
    backgroundImage: CustomPropTypes.inlineMediaQuery(PropTypes.shape({})),
    backgroundPosition: CustomPropTypes.inlineMediaQuery(PropTypes.string),
    justifyContent: CustomPropTypes.inlineMediaQuery(PropTypes.string),
    maxWidth: CustomPropTypes.inlineMediaQuery(PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl', 'full'])),
    padding: CustomPropTypes.inlineMediaQuery(PropTypes.shape({
      paddingTop: PropTypes.string,
      paddingRight: PropTypes.string,
      paddingLeft: PropTypes.string,
      paddintBottom: PropTypes.string
    })),
    margin: CustomPropTypes.inlineMediaQuery(PropTypes.shape({
      marginTop: PropTypes.string,
      marginBottom: PropTypes.string
    })),
    borderRadius: CustomPropTypes.inlineMediaQuery(PropTypes.shape({
      borderRadiusTopLeft: PropTypes.oneOf([PropTypes.string, PropTypes.number]),
      borderRadiusTopRight: PropTypes.oneOf([PropTypes.string, PropTypes.number]),
      borderRadiusBottomLeft: PropTypes.oneOf([PropTypes.string, PropTypes.number]),
      borderRadiusBottomRight: PropTypes.oneOf([PropTypes.string, PropTypes.number])
    })),
    loading: PropTypes.string
  }),
  innerBlocks: PropTypes.arrayOf(PropTypes.shape({}))
} : {};
var Group = BlockGroup;

export { Group as default };
